import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { PackageContentsPopoverComponent } from './package-contents-popover.component';
import { PackageContentsService } from '../../services/package-contents.service';
import { ItemCommonModule } from '../item-common.module';

@NgModule({
  imports: [CommonModule, GalaxyPopoverModule, GalaxyLoadingSpinnerModule, ItemCommonModule],
  exports: [PackageContentsPopoverComponent],
  declarations: [PackageContentsPopoverComponent],
  providers: [PackageContentsService],
})
export class PackageContentsPopoverModule {}
